import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { SELF_PAY_EVENTS } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/mixpanelConstants'
import {
  EapHpiNotificationType,
  useEapToHpiBannerState,
} from '@lyrahealth-inc/shared-app-logic/src/features/eligibility/hooks/useEapHpiBannerState'
import { EAP_TO_HPI_LINK_DESTINATION } from '@lyrahealth-inc/shared-app-logic/src/features/eligibility/hooks/useGetEapToHpiEligibilityText'
import { createEapHpiDestinationWebLink } from '@lyrahealth-inc/shared-app-logic/src/features/eligibility/utils'
import { EapToHpiBanner as EapToHpiBannerComponent } from '@lyrahealth-inc/ui-core-crossplatform/src/molecules/eapToHpiBanner/EapToHpiBanner'

import { getIsEapHpiInProductNotificationsEnabled } from '../../../data/featureFlags/featureFlagSelectors'
import { trackEventWithObj } from '../../../data/mixpanel'
import { useAppDispatch } from '../../../data/storeConfiguration/store'
import { getEapHpiHomebaseBannerNotificationState, getId } from '../../../data/user/userSelectors'
import { axiosInstance } from '../../http/axiosInstance'
import { triggerEapToHpiBannerCtaAction } from '../banner/banner-actions'

export const EapToHpiBanner: React.FC = () => {
  const lyraId = useSelector(getId)
  const isEapHpiInProductNotificationsEnabled = useSelector(getIsEapHpiInProductNotificationsEnabled)
  const eapHpiNotificationState = useSelector(getEapHpiHomebaseBannerNotificationState)
  const {
    isEapHpiBannerStateLoading,
    isEapHpiBannerVisible,
    sessionsRemaining,
    notificationType,
    dependentName,
    providerLyraId,
    sessionType,
    childLyraId,
    flowAs,
  } = useEapToHpiBannerState({
    userLyraId: lyraId,
    axiosInstance,
    isEapHpiInProductNotificationsEnabled,
    eapHpiNotificationState,
  })
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const onPressLink = async (linkDestination: EAP_TO_HPI_LINK_DESTINATION) => {
    trackEventWithObj({ event: SELF_PAY_EVENTS.CLICK_SELF_PAY_TRANSITION_HOMEBASE_BANNER })
    if (providerLyraId != null) {
      // providerId is required as it is used as a path param in the url and should always be present
      const routeDestination = createEapHpiDestinationWebLink({
        linkDestination,
        providerId: providerLyraId,
        sessionType,
        childLyraId,
      })

      const shouldCompleteEapToHpiBanner = notificationType === EapHpiNotificationType.VIEW_COST_ESTIMATE
      await dispatch(triggerEapToHpiBannerCtaAction(shouldCompleteEapToHpiBanner))
      navigate(routeDestination)
    }
  }

  if (isEapHpiBannerStateLoading || !isEapHpiBannerVisible) {
    return null
  }

  return (
    <EapToHpiBannerComponent
      onPressLink={onPressLink}
      sessionsRemaining={sessionsRemaining}
      dependentName={dependentName}
      flowAs={flowAs}
      notificationType={notificationType}
      showCloseIcon={false}
    />
  )
}
